
interface StepIndicatorProps {
  currentStep: 1 | 2 | 3;
}

const steps = [
  { number: 1, label: 'Create Account', icon: 'ri-user-add-line' },
  { number: 2, label: 'Business Profile', icon: 'ri-store-2-line' },
  { number: 3, label: 'Select Plan & Pay', icon: 'ri-bank-card-line' },
];

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <div className="flex items-center justify-between">
        {steps.map((step, idx) => (
          <div key={step.number} className="flex items-center flex-1">
            <div className="flex flex-col items-center flex-shrink-0">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold transition-all ${
                  currentStep > step.number
                    ? 'bg-teal-500 text-white'
                    : currentStep === step.number
                    ? 'bg-teal-600 text-white ring-4 ring-teal-100'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {currentStep > step.number ? (
                  <i className="ri-check-line text-xl"></i>
                ) : (
                  <i className={`${step.icon} text-xl`}></i>
                )}
              </div>
              <span
                className={`mt-2 text-xs font-semibold whitespace-nowrap ${
                  currentStep >= step.number ? 'text-teal-700' : 'text-gray-400'
                }`}
              >
                {step.label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <div className="flex-1 mx-4 mt-[-20px]">
                <div
                  className={`h-1 rounded-full transition-all ${
                    currentStep > step.number ? 'bg-teal-500' : 'bg-gray-200'
                  }`}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
